// NETWORK
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';

const useBulkSendRequest = () => {
  // Upload CSV file
  const uploadCSV = async (csvFile, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/bulk/csv`;
      const formData = new FormData();
      formData.set('file', csvFile);

      const options = {
        method: 'POST',
        body: formData,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      if (response?.status >= 400 && response?.status < 600) {
        errorHandler(responseJSON.error);
      }

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  // Update customer and user data
  const update = async (customerId, userId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/bulk/update`;
      const body = JSON.stringify({ customerId, userId });

      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      if (response?.status >= 400 && response?.status < 600) {
        errorHandler(responseJSON.error);
      }

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  // Send bulk SMS
  const sendBulkSMS = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/bulk/send`;

      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: typeof data === 'object' ? JSON.stringify(data) : data,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  // Fetch user data
  const getUser = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/user`;

      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  return {
    uploadCSV,
    update,
    sendBulkSMS,
    getUser,
  };
};
export default useBulkSendRequest;
